import React, { Component } from 'react'
import { Table } from 'hljd'
import columns from './columns'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
@observer
export default class extends Component {
  render() {
    const { activeTab, list } = this.props.store
    return (
      <Table
        rowKey={record => record.id}
        dataSource={toJS(list[activeTab])}
        columns={columns(this.props.store)}
        pagination={false}
      />
    )
  }
}
